import { createActionHelpers } from 'vuex-loading'
import api from '@/api'

const { startLoading } = createActionHelpers({ moduleName: 'loading' })

const MUTATION_TYPES = {
  setCustomField: 'SET_CUSTOM_FIELD',
  setCustomFields: 'SET_CUSTOM_FIELDS',
  addCustomField: 'ADD_CUSTOM_FIELD',
  setKYCCustomField: 'SET_KYC_CUSTOM_FIELD',
  setKYCCustomFields: 'SET_KYC_CUSTOM_FIELDS'
}

const state = {
  customFields: [],
  customField: null,
  KYCCustomFields: [],
  KYCCustomField: null
}

const mutations = {
  [MUTATION_TYPES.setCustomFields] (state, { customFields }) {
    state.customFields = customFields
  },
  [MUTATION_TYPES.setKYCCustomField] (state, { KYCCustomField }) {
    state.KYCCustomField = KYCCustomField
  },
  [MUTATION_TYPES.setKYCCustomFields] (state, { KYCCustomFields }) {
    state.KYCCustomFields = KYCCustomFields
  },
  [MUTATION_TYPES.addCustomField] (state, { customField }) {
    state.customFields.push(customField)
  },
  [MUTATION_TYPES.setCustomField] (state, { customField }) {
    state.customField = customField
  }
}

const actions = {
  async loadCustomFields ({ commit, dispatch }) {
    const { data: customFields } = await startLoading(dispatch, 'custom:fields:fetch', () => api.getCustomFields())

    commit(MUTATION_TYPES.setCustomFields, { customFields })
  },
  async loadKYCCustomFields ({ commit, dispatch }) {
    const { data: KYCCustomFields } = await startLoading(dispatch, 'custom:fields:fetch', () => api.getKYCCustomFields())

    commit(MUTATION_TYPES.setKYCCustomFields, { KYCCustomFields })
  },
  async saveKYCCustomField ({ commit, dispatch }, { customFieldData }) {
    const { data: KYCCustomField } = await startLoading(dispatch, 'custom:field:save', () => api.postKYCCustomField({ customFieldData }))

    commit(MUTATION_TYPES.setKYCCustomField, { KYCCustomField })
  },
  async saveCustomField ({ commit, dispatch }, { customFieldData }) {
    const { data: customField } = await startLoading(dispatch, 'custom:field:save', () => api.postCustomField({ customFieldData }))

    commit(MUTATION_TYPES.setCustomField, { customField })
  },
  async loadKYCCustomField ({ commit, dispatch }, { id }) {
    commit(MUTATION_TYPES.setKYCCustomField, { customField: null })
    if (!id) return

    const { data: KYCCustomField } = await startLoading(dispatch, `custom:field:${id}:fetch`, () => api.getKYCCustomField({ id }))

    commit(MUTATION_TYPES.setKYCCustomField, { KYCCustomField })
  },
  async loadCustomField ({ commit, dispatch }, { id }) {
    commit(MUTATION_TYPES.setCustomField, { customField: null })
    if (!id) return

    const { data: customField } = await startLoading(dispatch, `custom:field:${id}:fetch`, () => api.getCustomField({ id }))

    commit(MUTATION_TYPES.setCustomField, { customField })
  },
  async updateCustomField ({ commit, dispatch }, { customFieldData, id }) {
    const { data: customField } = await startLoading(dispatch, `custom:field:${id}:save`, () => api.putCustomField({ customFieldData, id }))

    commit(MUTATION_TYPES.setCustomField, { customField })
  },
  async updateKYCCustomField ({ commit, dispatch }, { customFieldData, id }) {
    const { data: KYCCustomField } = await startLoading(dispatch, `custom:field:${id}:save`, () => api.putKYCCustomField({ customFieldData, id }))

    commit(MUTATION_TYPES.setKYCCustomField, { KYCCustomField })
  }
}

const getters = {
  customFieldById: ({ customFields }) => (fieldId) => customFields.find(({ id }) => id === fieldId)
}

export default {
  state,
  mutations,
  actions,
  getters
}
